import { useQuery } from '@tanstack/react-query';
import { chatbotApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useAdminConversationDetail(conversationId: string | null) {
  return useQuery({
    queryKey: queryKeys.chatAdmin.conversationDetail(conversationId ?? ''),
    queryFn: ({ signal }) =>
      chatbotApiClient.getAnyConversation(
        conversationId as string,
        toCancelToken(signal),
      ),
    enabled: !!conversationId,
    // A persisted conversation transcript never changes.
    staleTime: Infinity,
    meta: { errorContext: 'admin conversation detail' },
  });
}
